import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";

export default function CTABand({ title = "Not sure where to begin?", body = "Answer five gentle questions and I'll point you to the support that fits your child, your family and how quickly you need help.", primary = { label: "Take the 2-minute assessment", to: "/sleep-assessment" }, secondary = { label: "Book a free 15-minute suitability call", to: "/book-a-call" } }) {
  return (
    <section className="py-20 sm:py-28" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-ink text-white px-6 py-14 sm:p-16 text-center">
            <div className="absolute -top-20 left-1/4 w-72 h-72 rounded-full bg-terra/20 blur-3xl" aria-hidden="true" />
            <div className="absolute -bottom-24 right-1/4 w-72 h-72 rounded-full bg-sage/20 blur-3xl" aria-hidden="true" />
            <div className="relative">
              <h2 className="font-serif text-3xl sm:text-4xl font-medium mb-4">{title}</h2>
              <p className="text-white/70 max-w-xl mx-auto mb-9 leading-relaxed">{body}</p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link to={primary.to} data-testid="cta-band-primary" className="btn-primary !bg-terra hover:!bg-terra-hover">
                  {primary.label} <ArrowRight className="w-4 h-4" />
                </Link>
                {secondary && (
                  <Link to={secondary.to} data-testid="cta-band-secondary" className="btn-secondary !text-white !border-white/30 hover:!bg-white/10 hover:!border-white/50">
                    {secondary.label}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
